module.exports = MaterialUI.Avatar;